import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'dashboardClicksOnLinksCreatedByCategory.list'

const DashboardClicksOnLinksCreatedByCategoryListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default DashboardClicksOnLinksCreatedByCategoryListSlice
